import imageSaver from 'helpers/drawit/imageSaver'
import textSaver from 'helpers/drawit/textSaver'
import tracesSaver from 'helpers/drawit/tracesSaver'

function loadImage(src) {
	return new Promise(res => {
		const img = document.createElement('img')
		if (!src) {
			res(img)
		} else {
			img.setAttribute('crossorigin', 'Anonymous')
			img.src = src
			img.onload = () => {
				res(img)
			}
		}
	})
}

async function createBackgroundImage(backgroundImage, width, height) {
	const img = await loadImage(backgroundImage)
	const canvas = document.createElement('canvas')
	canvas.width = width
	canvas.height = height
	if (img.width) {
		const ctx = canvas.getContext('2d')
		const imgWidth = img.width
		const imgHeight = img.height
		const imgRel = imgWidth / imgHeight
		const canvasRel = width / height
		let drawWidth, drawHeight
		if (imgRel > canvasRel) {
			drawWidth = width
			drawHeight = imgHeight * width / imgWidth
		} else {
			drawHeight = imgHeight
			drawWidth = imgWidth * height / imgHeight
		}
		const drawX = (width - drawWidth) / 2
		const drawY = (height - drawHeight) / 2
		ctx.drawImage(img, 0, 0, imgWidth, imgHeight, drawX, drawY, drawWidth, drawHeight)
	}
	return canvas
}

async function createImageData(answers, backgroundImage) {
	const width = 1024
	const height = 768

	const backgroundImagePromise = createBackgroundImage(backgroundImage, width, height)
	const imageLayerPromise = imageSaver(answers, width, height)
	const textLayerPromise = textSaver(answers, width, height)
	const tracesLayerPromise = tracesSaver(answers, width, height)
	const layers = await Promise.all([backgroundImagePromise, imageLayerPromise, textLayerPromise, tracesLayerPromise])

	const canvas = document.createElement('canvas')
	canvas.width = width
	canvas.height = height
	const ctx = canvas.getContext('2d')
	layers.forEach(layer => {
		ctx.drawImage(layer, 0, 0)
	})
	// document.getElementsByTagName('body')[0].appendChild(canvas)

	return canvas.toDataURL()
}

export default createImageData
